import Endpoints from "./Endpoints";
export default Endpoints